import { createAction, props } from "@ngrx/store";

const prefix = "[Skill Alias Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const requestDeleteSkillAlias = createAction(
  `${prefix} Request Delete Skill Alias`,
  props<{ parentSkillId: string; childSkillId: string }>(),
);
